import api from "../services/api";

// ID fixo da extensão (derivado do "key" do manifest — ver Task 3 do plano).
export const CONECTOR_EXTENSION_ID = "emeakeepmonknopckkohoidgchdobnhl";

const PROBE_TIMEOUT_MS = 1500;

export function compareVersions(a, b) {
  const pa = String(a || "0").split(".").map(n => parseInt(n, 10) || 0);
  const pb = String(b || "0").split(".").map(n => parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const x = pa[i] || 0;
    const y = pb[i] || 0;
    if (x > y) return 1;
    if (x < y) return -1;
  }
  return 0;
}

export function resolveExtensionState(detected, info) {
  if (!detected || !detected.installed) return "absent";
  const current = info && info.version;
  if (!current) return "up-to-date";
  return compareVersions(detected.version, current) < 0 ? "outdated" : "up-to-date";
}

export function detectConectorExtension(timeoutMs = PROBE_TIMEOUT_MS) {
  return new Promise(resolve => {
    if (typeof document === "undefined") {
      resolve({ installed: false, version: null });
      return;
    }
    let done = false;
    const finish = val => {
      if (done) return;
      done = true;
      resolve(val);
    };
    const script = document.createElement("script");
    script.src = `chrome-extension://${CONECTOR_EXTENSION_ID}/probe.js`;
    script.onload = () => {
      const info = typeof window !== "undefined" ? window.__CONECTOR_WA__ : null;
      finish(info
        ? { installed: true, version: info.version || null }
        : { installed: false, version: null });
      script.remove();
    };
    script.onerror = () => {
      finish({ installed: false, version: null });
      script.remove();
    };
    document.head.appendChild(script);
    setTimeout(() => finish({ installed: false, version: null }), timeoutMs);
  });
}

export async function fetchExtensionInfo() {
  try {
    const { data } = await api.get("/api/extension/info");
    return {
      version: data && data.version ? data.version : null,
      downloadUrl: (data && data.downloadUrl) || "/public/downloads/conector-whatsapp.zip"
    };
  } catch (err) {
    return { version: null, downloadUrl: "/public/downloads/conector-whatsapp.zip" };
  }
}
